import { LANGUAGES } from '@rc-d2c/context-manager';

export const SUPPORTED_LOCALES = [
  LANGUAGES.frFR,
  LANGUAGES.enUS,
  LANGUAGES.nlNL,
  LANGUAGES.deDE,
  LANGUAGES.svSE,
  LANGUAGES.trTR,
  LANGUAGES.enGB,
];

export const COUNTRY_FALLBACK_LOCALES = {
  fr: LANGUAGES.frFR,
  nl: LANGUAGES.nlNL,
  de: LANGUAGES.deDE,
  se: LANGUAGES.svSE,
  tr: LANGUAGES.trTR,
  en: LANGUAGES.enUS,
};

export const DEFAULT_LOCALE = LANGUAGES.enUS;
